import { ComponentProps } from 'react';

export enum ButtonVariants {
  primary = 'primary',
  secondary = 'secondary',
  transparent = 'transparent',
  pokerTable = 'pokerTable',
}
export enum ButtonSizes {
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  none = 'none',
}

type ButtonProps = {
  variant?: ButtonVariants;
  fullWidth?: boolean;
  size?: ButtonSizes;
} & ComponentProps<'button'>;

const Button = ({
  variant = ButtonVariants.primary,
  fullWidth = false,
  size = ButtonSizes.lg,
  className,
  ...props
}: ButtonProps) => {
  const variantStyle = (() => {
    switch (variant) {
      case ButtonVariants.primary:
        return 'bg-ph-primary-violet hover:bg-none hover:bg-ph-primary-violet text-white';
      case ButtonVariants.secondary:
        return 'bg-ph-gray-cod border border-ph-gray-silver text-ph-gray-silver hover:text-ph-secondary-portage  hover:border-ph-secondary-portage active:text-white active:border-white';
      case ButtonVariants.transparent:
        return 'text-ph-gray-silver hover:text-ph-secondary-portage  active:text-white bg-transparent';
      case ButtonVariants.pokerTable:
        return 'poker-user-actions-button text-white opacity-50';
    }
  })();

  const variantStyleDisabled = (() => {
    switch (variant) {
      case ButtonVariants.pokerTable:
        return 'poker-user-actions-button opacity-20';
      default:
        return 'bg-ph-gray-baltic text-ph-gray-jumbo hover:cursor-not-allowed border-none';
    }
  })();

  const sizeStyle = (() => {
    switch (size) {
      case ButtonSizes.lg:
        return 'px-5 py-3 h-12';
      case ButtonSizes.md:
        return 'px-5 py-2';
      case ButtonSizes.sm:
        return 'px-4 py-2';
      case ButtonSizes.none:
        return '';
      default:
        return 'p-5 py-3';
    }
  })();

  return (
    <button
      className={`font-manrope rounded-lg text-sm font-bold leading-5 tracking-wide ${!props.disabled ? variantStyle : variantStyleDisabled} ${fullWidth && false}, ${sizeStyle} ${className}`}
      {...props}
    >
      {props.children}
    </button>
  );
};

export default Button;
